import {
  uploadAttachmentDocumentPath,
  uploadAttachmentPath,
} from '../constants/apiEndpoints';
import { notificationType } from '../constants/globals';
import { attachmentActions } from '../reducers/attachmentFile';
import { createNotification } from '../utils';
import { errorAction } from '../utils/actions';
import apiService from '../utils/apiService';

export const uploadAttachment = (data, messages, callback) => {
  return (dispatch) => {
    dispatch(attachmentActions.actionStart());
    return apiService
      .post(uploadAttachmentPath(), data)
      .then((response) => {
        callback();
        createNotification(
          notificationType.success,
          messages?.title,
          response.data
        );
        dispatch(attachmentActions.stopLoading());
      })
      .catch((err) => {
        errorAction(err, attachmentActions.actionError, dispatch, messages);
      });
  };
};

export const getAttachmentFile = (messages) => (dispatch) => {
  dispatch(attachmentActions.actionStart());
  return apiService
    .getFromFile(uploadAttachmentDocumentPath())
    .then((response) => {
      openAttachmenInNewTab(response.data);
      dispatch(attachmentActions.stopLoading());
    })
    .catch((err) => {
      errorAction(err, attachmentActions.actionError, dispatch, messages);
      if (err?.response?.status === 400) {
        createNotification(
          notificationType.error,
          messages.errorTitle,
          messages.unsuccessfulPreviewDocument
        );
      }
    });
};

function openAttachmenInNewTab(data) {
  const blob = new Blob([data], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);
  window.open(url, '_blank');
  URL.revokeObjectURL(url);
}
